import React, { useState } from 'react';
import { withStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import styles from './styles';
import DMTTab from './DMTTab';
import PF2MTabs from '~/components/PF2MTabs';

const DMT = () => {
  const { t: translate } = useTranslation();
  const [selectedTab, setSelectedTab] = useState(0);

  const tabs = [
    { key: 0, label: translate('common:DMT') },
  ];
  const handleChange = (event, value) => {
    setSelectedTab(value);
  };

  return (
    <>
      <PF2MTabs
        value={selectedTab}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
      >
        {tabs}
      </PF2MTabs>
      {selectedTab === 0 ? (<DMTTab />) : null}
    </>
  );
};

export default withStyles(styles)(DMT);
